// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pac-container {
  z-index: 1051;
  min-width: 250px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/overrides/google-autocomplete.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".pac-container {\n  z-index: 1051;\n  min-width: 250px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
